export default __webpack_public_path__ + "images/ca76f42ffd8f5f8c4e8612c06d9cb6a4.png";